import React from "react";
import Header from "../../components/Header/Header";
import s from "./CreateService.module.scss";
import { Button, Col, Form, Row, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import Footer from "../../components/Footer/Footer";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { IServiceRequest } from "../../types";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store";
import { createService, getServicesList } from "../../redux/ServiceSlice";
import { ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const CreateService = () => {
  const [form] = useForm();
  const dispatch: AppDispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const countries = useSelector(
    (state: RootState) => state.application.countries,
  );

  const brokers = useSelector(
    (state: RootState) => state.user.managerEmployeesList,
  );

  const addService = async (values: IServiceRequest) => {
    const res = await dispatch(
      createService({
        broker: values.broker,
        service_name: values.service_name,
        price: values.price,
        comment: values.comment,
        is_active: true,
      }),
    );

    if (res.type === "services/createService/fulfilled") {
      dispatch(getServicesList(1));
      toast.success("Вы добавили новую услугу");
      navigate("/services");
    }
  };

  return (
    <div className={s.createService}>
      <ToastContainer />
      <Header />
      <div className={s.content}>
        <Link to="/services" className={s.back}>
          <ArrowLeftOutlined className={s.left} /> {t("Назад")}
        </Link>
        <h2 className={s.h2}>{t("Добавить новую услугу")}</h2>
        <div className={s.form}>
          <Form
            layout="vertical"
            className={"create_application"}
            form={form}
            onFinish={addService}
          >
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  name="service_name"
                  label={t("Наименование услуги")}
                  rules={[
                    {
                      required: true,
                      message: t("Укажите услугу"),
                    },
                  ]}
                >
                  <input
                    placeholder={t("Укажите услугу")}
                    className={s.input}
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="price"
                  label={t("Цена, USD")}
                  rules={[
                    {
                      required: true,
                      message: t("Укажите цену, USD"),
                    },
                  ]}
                >
                  <input
                    placeholder={t("Укажите  цену в USD")}
                    className={s.input}
                    onInput={(e) => {
                      e.currentTarget.value = e.currentTarget.value.replace(
                        /[^\d]/g,
                        "",
                      );
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  name="broker"
                  label={t("Брокер/Компания")}
                  rules={[
                    {
                      required: true,
                      message: t("Укажите брокера/компанию"),
                    },
                  ]}
                >
                  <Select
                    className={s.select}
                    placeholder={t("Выберите брокера")}
                    options={brokers?.results?.map((it) => ({
                      value: it?.id,
                      label: `${it.company_name ? it.company_name : it.full_name} - ${it.email}`,
                    }))}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="comment" label={t("Комментарий")}>
                  <textarea
                    placeholder={t("Комментарий")}
                    className={s.input}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row className={s.btns}>
              <Button className={s.btn} htmlType="submit">
                {t("Создать услугу")}
              </Button>
            </Row>
          </Form>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CreateService;
